class ShareButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.shareButton = this.querySelector('button');

    this.handleClick = this.handleClick.bind(this);

    this.shareButton.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.shareButton.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    if (navigator.share) {
      const title = window.document.title;
      const url = window.document.location.href;
      navigator.share({
        title: `${title}`,
        url: `${url}`,
      }).then(() => {
        console.log('The page has been shared')
      }).catch(console.error)
    }
  }
}

customElements.define('share-button', ShareButton);
